import type { SelectGroupLabelProps } from '@base-ui/react';

import { Select as BaseSelect } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { groupLabelStyle } from '../form.css';

type Props = SelectGroupLabelProps;

export const SelectGroupLabel = ({ ...delegated }: Props) => {
  return <BaseSelect.GroupLabel {...delegated} className={clsxs(groupLabelStyle, delegated.className)} />;
};
